const Loading = () => {
	return <div className='h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin' />;
};

export default Loading;
